import { format } from 'date-fns';
import { Project } from '~/types/project';

export default function bidDeadline(project: Project) {
  const bidDeadline = project?.bidDeadline || project?.portfolio?.bidDeadline;
  return bidDeadline && `Bidding due ${format(new Date(bidDeadline), 'MMM dd')}`;
}